import { useEffect } from 'react';

// Sets the tab title while the page is mounted and restores the previous one afterwards.
const useDocumentTitle = (title) => {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
};

export default useDocumentTitle;
